import en from "./locales/en.json";
import zh from "./locales/zh.json";
import { cross_en, cross_zh } from "@adgm/cross-i18n";
import { EN, ZH_CN, isClient, LANGUAGE } from "@adgm/libs";

const chekLanguage: () => string = () => {
  if (isClient) {
    localStorage.setItem(LANGUAGE, EN);
    if (location.pathname.includes(EN)) {
      localStorage.setItem(LANGUAGE, EN);
    }
    if (location.pathname.includes(ZH_CN)) {
      localStorage.setItem(LANGUAGE, ZH_CN);
    }
  }
  return !isClient ? EN : (localStorage.getItem(LANGUAGE) ?? "");
};

const i18nUtil = {
  locales: [EN, ZH_CN],
  locale: chekLanguage(),
  updateLocale: (language: string) => {
    i18nUtil.locale = language;
  },
  t: () => {
    let res;
    switch (i18nUtil.locale) {
      case ZH_CN:
        res = { ...zh, ...cross_zh };
        break;
      case EN:
        res = { ...en, ...cross_en };
        break;
      default:
        res = { ...zh, ...cross_zh };
    }
    return res;
  },
  formatMessage: (id: { id: string }, option?: object) => {
    const _idd: string = Object.values(id)[0] ?? "";
    const _str = i18nUtil.t()[_idd];
    let _resStr = _str;
    if (option) {
      Object.keys(option).map(() => {
        const keyReg = new RegExp(/\{.*?\}/g);
        const res = _str?.match(keyReg);
        if (res?.length > 0) {
          res.map((r: string) => {
            if (r && _str.includes(r)) {
              const _key = r.replace("{", "").replace("}", "");
              _resStr = _resStr?.replaceAll && _resStr.replaceAll(r, option[_key]);
            }
          });
        }
      });
    }
    return _resStr;
  },
};

export { i18nUtil };
